import { consultaCA } from '../configs/functions';
import dayjs from 'dayjs';
import {
    Alert,
    Autocomplete, Button,
    Checkbox,
    CircularProgress, Dialog, DialogActions, DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';
import { getFormErrorMessage, renderDay } from '../../../../../configs/functions';
import ProductImageUpload from '../../../../common/ProductImageUpload';
import { useCommonItems } from '../../../../../contexts/CommonItensProvider';
import React, {useEffect, useState} from "react";

// Etapa 01 do formulário
export function StepProductsInfo({
                                     control,
                                     register,
                                     setValue,
                                     getValues,
                                     errors,
                                     setError,
                                     clearErrors,
                                     watch,
                                     trigger,
                                     exibiAlertaAutoPreenchimento,
                                     setExibiAlertaAutoPreenchimento,
                                     selectedProduct,
                                     categorias,
                                     unidadesDeMedida,
                                     setSelectedCategory,
                                     isEditAction,
                                     actionsAllowed,
                                     empresasAssociadas
                                 }) {
    const { handleCloseDialog, exibirAlerta, exibirDialog } = useCommonItems();

    const [selectedEmpresa, setSelectedEmpresa] = useState({});

    const [originalCA, setOriginalCA] = useState(null);
    const [openModalCA, setOpenModalCA] = useState(false);
    const [modalCAaccept, setModalCAaccept] = useState(false);

    const [originalCategoria, setOriginalCategoria] = useState(null);
    const [pendingCategoria, setPendingCategoria] = useState(null);
    const [openModalCategoria, setOpenModalCategoria] = useState(false);

    const caValue = watch("ca");

    const handleCloseModalCA = () => setOpenModalCA(false);
    const handleCloseModalCategoria = () => {
        setOpenModalCategoria(false);
        setPendingCategoria(null);
    };

    const handleConfirmCategoria = () => {
        if (pendingCategoria) {
            setValue('id_categorias', pendingCategoria.nome, { shouldValidate: true, shouldDirty: true });
            setSelectedCategory(pendingCategoria);
            setValue('existsGheWithThisCategory', false);
        }
        setOpenModalCategoria(false);
        setPendingCategoria(null);
    };

    const buscaProdutoCA = async () => {
        try {
            clearErrors();
            exibirDialog('Pesquisando C.A. informado...');
            const result = await consultaCA(getValues('ca')).finally(() => {
                handleCloseDialog();
            });
            const produtoGOV = result.data[0];
            if (produtoGOV) {
                if (produtoGOV.situacao !== 'VÁLIDO') {
                    setValue('nome', '');
                    setValue('descricao', '');
                    setValue('indicacao', '');
                    setValue('precaucao', '');
                    setValue('observacao', '');
                    setValue('validade_ca', null);
                    setValue('id_categorias', null);
                    setValue('id_unidadeMedida', null);
                    exibirAlerta('Problemas com o C.A.', `O status do C.A informado é ${produtoGOV.situacao}. Verifique os dados informados ou informe manualmente as informações.`, 'error')
                    setExibiAlertaAutoPreenchimento(false);
                } else {
                    setExibiAlertaAutoPreenchimento(true);
                    setValue('nome', produtoGOV.nome);
                    setValue('descricao', produtoGOV.descricao);
                    setValue('indicacao', produtoGOV.aprovadoParaLaudo);
                    setValue('precaucao', produtoGOV.restricaoLaudo);
                    setValue('observacao', produtoGOV.observacaoLaudo);
                    setValue('validade_ca', dayjs.utc(new Date(produtoGOV.validade)));
                }
            } else {
                exibirAlerta('Problemas com o C.A.', 'Nenhum produto encontrado com o C.A. informado!', 'error')
                exibirAlerta('Problemas com o C.A.', 'Nenhum produto encontrado com o C.A. informado!', 'error')
            }
        } catch (error) {
            return error;
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            buscaProdutoCA();
        }
    };

    const getFormattedOptions = () => {
        if (!unidadesDeMedida.length) return [];

        // Verificar se há unidades com contrato
        const hasContrato = unidadesDeMedida.some(u => u.contrato);

        if (hasContrato) {
            // Filtrar por contrato se existir
            return unidadesDeMedida.filter(u => u.contrato?.id === selectedEmpresa.idContrato);
        } else {
            // Retornar todas se não houver contrato
            return unidadesDeMedida;
        }
    };

    const getOptionLabel = (option) => {
        if (!option) return "";

        return option.nome ||
            option.tipo ||
            "Unidade não identificada";
    };

    useEffect(() => {
        if (selectedProduct && empresasAssociadas.length > 0) {
            const empresa = empresasAssociadas.find(
                empresa => selectedProduct.idEmpresa === empresa.id
            );
            setSelectedEmpresa(empresa || null);
        }
    }, [selectedProduct, empresasAssociadas]);

    useEffect(() => {
        if (selectedProduct && selectedEmpresa && selectedEmpresa.id) {
            const unidadeId = selectedProduct.unidadeMedida?.id;

            setValue(`id_unidadeMedida.${selectedEmpresa.id}`, unidadeId, {
                shouldValidate: false,
                shouldDirty: false
            });

            setTimeout(() => {
                const check = getValues(`id_unidadeMedida.${selectedEmpresa.id}`);
            }, 0);
        }
    }, [selectedProduct, selectedEmpresa, setValue]);

    useEffect(() => {
        if (selectedProduct) {
            setValue("ca", selectedProduct.ca);
            setOriginalCA(selectedProduct.ca);
        }
    }, [selectedProduct]);


    useEffect(() => {
        if (!originalCA) return;
        if (caValue !== originalCA && !modalCAaccept) {
            setOpenModalCA(true);
            setModalCAaccept(true);
        }
    }, [caValue, originalCA]);

    useEffect(() => {
        if (selectedProduct) {
            setOriginalCategoria(getValues('id_categorias'));
        }
    }, [selectedProduct]);

    useEffect(() => {
        trigger('validade_ca');
    }, [caValue, trigger]);

    return (
        <>
            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={6}>
                <Grid item xs={12} md={8} >
                    <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="CA"
                                placeholder="Digite o CA do Produto"
                                autoComplete='off'
                                error={errors.ca && true}
                                helperText={errors.ca && 'O CA é obrigatória.'}
                                fullWidth
                                {...register('ca')}
                                variant="outlined"
                                onKeyDown={handleKeyDown}
                                disabled={!actionsAllowed}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Buscar produto pelo C.A." arrow>
                                                <IconButton onClick={() => buscaProdutoCA()} disabled={!actionsAllowed}>
                                                    <Search />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="validade_ca"
                                control={control}
                                rules={{
                                    validate: (value) => {
                                        if (!caValue) return true;
                                        if (!value) return 'Informe a validade do CA';
                                        if (!dayjs(value).isValid()) return 'Data inválida';
                                        if (dayjs(value).isBefore(dayjs(), 'day')) return 'Equipamento com CA vencido';

                                        return true;
                                    },
                                }}
                                render={({ field: { ref, value, onChange, ...field } }) => (
                                    <DatePicker
                                        sx={{ mt: 1 }}
                                        label="Validade do CA"
                                        format="DD/MM/YYYY"
                                        disablePast
                                        openTo="year"
                                        views={['year', 'month', 'day']}
                                        dayOfWeekFormatter={renderDay}
                                        value={value || null}
                                        onChange={(newValue) => {
                                            setValue('validade_ca', newValue, { shouldDirty: true, shouldValidate: true });
                                        }}
                                        slotProps={{
                                            textField: {
                                                error: !!errors.validade_ca,
                                                helperText: errors.validade_ca ? errors.validade_ca.message : null,
                                                InputLabelProps: { shrink: true },
                                                required: !!caValue,
                                            },
                                        }}
                                        TextField={(params) => (
                                            <TextField
                                                {...field}
                                                {...params}
                                                autoComplete="off"
                                                fullWidth
                                                type="date"
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="Nome"
                                disabled={!actionsAllowed || isEditAction}
                                required
                                placeholder="Digite o nome do produtos"
                                name="nome"
                                autoComplete='off'
                                error={errors.nome && true}
                                helperText={errors.nome && 'O Nome é obrigatório.'}
                                fullWidth
                                {...register('nome', { required: true })}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="descricao"
                                control={control}
                                defaultValue=""
                                rules={{ required: 'A Descrição é obrigatória.' }}
                                disabled={!actionsAllowed}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        InputLabelProps={{ shrink: true }}
                                        margin="dense"
                                        label="Descrição"
                                        required
                                        placeholder="Digite a Descrição"
                                        error={errors.descricao && true}
                                        helperText={errors.descricao && 'A Descrição é obrigatória.'}
                                        fullWidth
                                        multiline
                                        rows={2}
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="indicacao"
                                control={control}
                                defaultValue=""
                                rules={{ required: 'A Indicação é obrigatória.' }}
                                disabled={!actionsAllowed}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        InputLabelProps={{ shrink: true }}
                                        margin="dense"
                                        label="Indicação"
                                        required
                                        placeholder="Digite a Indicação"
                                        name="indicacao"
                                        error={errors.indicacao && true}
                                        helperText={errors.indicacao && 'A Indicação é obrigatória.'}
                                        fullWidth
                                        multiline
                                        rows={2}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="precaucao"
                                control={control}
                                defaultValue=""
                                disabled={!actionsAllowed}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        InputLabelProps={{ shrink: true }}
                                        margin="dense"
                                        label="Precaução"
                                        placeholder="Digite a Precaução"
                                        name="precaucao"
                                        fullWidth
                                        multiline
                                        rows={2}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="observacao"
                                control={control}
                                defaultValue=""
                                disabled={!actionsAllowed}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        InputLabelProps={{ shrink: true }}
                                        margin="dense"
                                        label="Observação"
                                        placeholder="Digite a Observação"
                                        name="observacao"
                                        fullWidth
                                        multiline
                                        rows={2}
                                    />
                                )}
                            />
                            <Divider variant="middle" sx={{ mt: 2, mb: 1 }} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Controller
                                name="id_categorias"
                                control={control}
                                rules={{ required: 'A Categoria é obrigatória.' }}
                                disabled={!actionsAllowed}
                                render={({ field: { ref, onChange, value, ...field } }) => (
                                    <>
                                        {categorias.length > 0 ? (
                                            <Autocomplete
                                                {...field}
                                                options={categorias}
                                                getOptionLabel={(option) => option.nome}
                                                noOptionsText="Nenhuma Categoria encontrada"
                                                isOptionEqualToValue={(option, value) => option.nome === value.nome}
                                                value={categorias.find((option) => option.nome === value) || null}
                                                onChange={(event, newValue) => {
                                                    if (newValue !== null) {
                                                        if (isEditAction && originalCategoria && newValue.nome !== originalCategoria) {
                                                            setPendingCategoria(newValue);
                                                            setOpenModalCategoria(true);
                                                            return;
                                                        }

                                                        onChange(newValue.nome);
                                                        setSelectedCategory(newValue);
                                                        setValue('existsGheWithThisCategory', false);
                                                    } else {
                                                        onChange(null);
                                                        setSelectedCategory(null);
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Categoria"
                                                        required
                                                        autoComplete='off'
                                                        error={!!errors.id_categorias}
                                                        helperText={errors.id_categorias && 'A Categoria é obrigatória.'}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        placeholder="Selecione uma Categoria"
                                                    />
                                                )}
                                            />
                                        ) : (
                                            <Typography variant='span' sx={{ color: 'grey' }}>*Não foram encontradas categorias</Typography>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        {isEditAction && selectedEmpresa && selectedEmpresa.id && (
                            <Grid item xs={12} md={6}>
                                <Controller
                                    name={`id_unidadeMedida.${selectedEmpresa.id}`}
                                    control={control}
                                    rules={{ required: 'A Unidade de Medida é obrigatória.' }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            disabled={
                                                unidadesDeMedida.length === 1 &&
                                                !unidadesDeMedida[0]?.contrato
                                            }
                                            {...field}
                                            options={getFormattedOptions()}
                                            getOptionLabel={getOptionLabel}
                                            noOptionsText="Nenhuma Unidade encontrada"
                                            isOptionEqualToValue={(option, value) => {
                                                // Comparação mais robusta
                                                if (!option || !value) return option === value;

                                                const optionId = option.id || option.value;
                                                const valueId = typeof value === 'object' ? (value.id || value.value) : value;

                                                return optionId === valueId;
                                            }}
                                            value={
                                                (() => {
                                                    let fieldValue = field.value;

                                                    if (Array.isArray(fieldValue)) {
                                                        fieldValue = fieldValue.flat().filter(v => v != null).pop();
                                                    }

                                                    // Se for objeto, pegar o ID
                                                    const idToFind = typeof fieldValue === 'object' && fieldValue !== null
                                                        ? fieldValue.id
                                                        : fieldValue;

                                                    const options = getFormattedOptions();
                                                    const found = options.find((option) => option.id === idToFind);

                                                    // Se não encontrou nas opções mas tem valor, tentar buscar na lista original
                                                    if (!found && idToFind && unidadesDeMedida.length) {
                                                        const fallbackFound = unidadesDeMedida.find(option => option.id === idToFind);
                                                        if (fallbackFound) {
                                                            return fallbackFound;
                                                        }
                                                    }

                                                    return found || null;
                                                })()
                                            }
                                            onChange={(event, value) => {
                                                const newValue = value?.id || null;

                                                setValue(`id_unidadeMedida.${selectedEmpresa.id}`, newValue, {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                });

                                                setTimeout(() => {
                                                    const check = getValues(`id_unidadeMedida.${selectedEmpresa.id}`);
                                                    console.log('Valor selecionado:', check);
                                                }, 0);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={`Unidade de Medida`}
                                                    required
                                                    autoComplete="off"
                                                    error={!!errors?.id_unidadeMedida?.[selectedEmpresa.id]}
                                                    helperText={errors?.id_unidadeMedida?.[selectedEmpresa.id]}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder="Selecione uma Unidade de Medida"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Grid>
                        )}

                        {isEditAction && (
                            <Grid item xs={12} md={6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    margin='dense'
                                    label='Vida Útil do EPI'
                                    type='number'
                                    inputProps={{ min: 1 }}
                                    placeholder='Digite a Vida Útil do EPI'
                                    error={!!errors.vida_util}
                                    helperText={getFormErrorMessage(errors, 'vida_util')}
                                    {...register("vida_util", { required: true })}
                                    disabled={!actionsAllowed}
                                    autoComplete='off'
                                    InputProps={{
                                        endAdornment: <Typography color="textSecondary">dias</Typography>,
                                    }}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...register('exibirRelatorio')}
                                    defaultChecked={getValues('exibirRelatorio')}
                                    onChange={(event) => {
                                        setValue('exibirRelatorio', event.target.checked);
                                    }}
                                    disabled={!actionsAllowed}
                                />
                            }
                            label="Exibir Produto na Ficha de EPI"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...register('for_machine')}
                                    defaultChecked={!!getValues('for_machine')}
                                    onChange={(event) => {
                                        setValue('for_machine', event.target.checked);
                                    }}
                                    disabled={!actionsAllowed}
                                />
                            }
                            label="Produto utilizado em Máquina"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...register('for_locker')}
                                    defaultChecked={!!getValues('for_locker')}
                                    onChange={(event) => {
                                        setValue('for_locker', event.target.checked);
                                    }}
                                    disabled={!actionsAllowed}
                                />
                            }
                            label="Produto utilizado em Armário"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...register('enviar_alerta')}
                                    defaultChecked={!!getValues('enviar_alerta')}
                                    onChange={(event) => {
                                        setValue('enviar_alerta', event.target.checked);
                                    }}
                                    disabled={!actionsAllowed}
                                />
                            }
                            label="Gerar alertas para esse produto"
                        />
                    </FormGroup>
                    <Typography p>Foto do Produto</Typography>
                    <ProductImageUpload getValues={getValues} setValue={setValue} actionsAllowed={actionsAllowed} />
                </Grid>

                {exibiAlertaAutoPreenchimento && (
                    <Grid item xs={12}>
                        <Alert
                            severity="warning" sx={{ mr: 3, fontSize: '0.7rem' }}>
                            Esteja ciente de que as informações preenchidas automaticamente no formulário de cadastro do produto,
                            utilizando o número de Certificação de Aprovação (CA), requerem revisão minuciosa antes da submissão final.
                            Ressaltamos que a responsabilidade pela exatidão dos dados é da empresa contratante.
                        </Alert>
                    </Grid>
                )}
            </Grid>

            <Dialog open={openModalCA} onClose={handleCloseModalCA}>
                <DialogTitle>Atenção</DialogTitle>

                <DialogContent dividers>
                    <Typography>
                        Ao alterar o CA, será criada uma <strong>nova versão</strong> deste produto.
                        Isso garante o histórico correto para auditorias e rastreabilidade.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseModalCA} variant="contained">Entendi</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openModalCategoria} onClose={handleCloseModalCategoria}>
                <DialogTitle>Atenção</DialogTitle>

                <DialogContent dividers>
                    <Typography>
                        Ao alterar a categoria deste produto, as permissões atualmente cadastradas nos GHEs
                        (Grupos Homogêneos de Exposição) vinculados serão <strong>excluídas</strong>.
                        Serão criadas novas permissões, de forma <strong>inativa</strong>, para os GHEs em que
                        a categoria selecionada estiver configurada.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseModalCategoria}>Cancelar</Button>
                    <Button onClick={handleConfirmCategoria} variant="contained">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};